import {
  Box,
  Button,
  Card,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import TrimPiece from "./TrimPiece";
import OptimizedFlats from "../OptimizedFlats";
import CompanyTrimCatalogDialog from "../../../../../components/NewDetail/views/OrderItems/Trim/CompanyTrimCatalogDialog";
import AddNewTrimDialog from "./AddNewTrimDialog";
import { v4 as uuidv4 } from "uuid";
import TextFieldDebouncedNoInitialLoad from "../../../../../components/TextFieldDebouncedNoInitialLoad";
import {
  currencyFormatNoDecimals,
  toTwoDecimals,
} from "../../../../../components/NewDetail/calculations/utils";
import AdornedInputDebouncedNoInitialLoad from "../../../../../components/AdornedInputDebouncedNoInitialLoad";
import useGalvanizedFlatOptions from "../../../../../hooks/useGalvanizedFlatOptions";

const TrimAndFlashing = ({
  isTollForm,
  flatSheetSize,
  defaultVariables,
  companyId,
  orderItem,
  onUpdate,
  trimType = "TrimAndFlashing", // TrimAndFlashing, CopingCap, CopingCapCleat, SplicePlate
}) => {
  console.log("isTollForm", isTollForm);
  const { galvanizedFlatOptions } = useGalvanizedFlatOptions(); // used only if CopingCapCleat
  const [addTrimDialogOpen, setAddTrimDialogOpen] = useState(false);
  const [openMasterCatalog, setOpenMasterCatalog] = useState(false);

  let title = "";
  let piecesKey = "";
  let pieceName = "";
  switch (trimType) {
    case "TrimAndFlashing":
      title = "Trim & Flashing";
      piecesKey = "trimPieces";
      pieceName = "trim";
      break;
    case "CopingCap":
      title = "Coping Cap";
      piecesKey = "capPieces";
      pieceName = "cap";
      break;
    case "CopingCapCleat":
      title = "Coping Cap Cleat";
      piecesKey = "cleatPieces";
      pieceName = "cleat";
      break;
    case "SplicePlate":
      title = "Splice Plate";
      piecesKey = "plates";
      pieceName = "cleat";
      break;
  }

  const onAddTrim = (newTrim) => {
    console.log("TRIM ADDED", newTrim);

    let piecesCopy = [...orderItem[piecesKey]];
    let newPieceDetails = {};
    newPieceDetails[pieceName] = newTrim;

    //TODO: CHECK IF MASTER TRIM
    // IF MASTER TRIM, USE THE PRE-DEFINED MASTER HITS AND STRETCHOUT
    piecesCopy.push({
      quantity: 1,
      stretchOut: newTrim.isMasterCatalog
        ? Number(newTrim.masterStretchOut)
        : 1,
      ...newPieceDetails,
      // trim: newTrim,
      hits: newTrim.isMasterCatalog ? Number(newTrim.masterHits) : 1,
      name: newTrim.name,
      image: newTrim.image,
      variables: { ...defaultVariables },
    });
    console.log("Piece Added", piecesCopy);

    let update = {};
    update[piecesKey] = piecesCopy;
    onUpdate({
      ...orderItem,
      ...update,
    });
  };
  const onAddSplicePlate = () => {
    let piecesCopy = [...orderItem[piecesKey]];
    piecesCopy.push({
      quantity: 1,
      stretchOut: 1,
      width: 1,
      hits: 1,
      variables: { ...defaultVariables },
    });
    console.log("Piece Added", piecesCopy);

    let update = {};
    update[piecesKey] = piecesCopy;
    onUpdate({
      ...orderItem,
      ...update,
    });
  };

  const onRemovePiece = (index) => {
    let piecesCopy = [...orderItem[piecesKey]];
    piecesCopy.splice(index, 1);

    let update = {};
    update[piecesKey] = piecesCopy;
    onUpdate({
      ...orderItem,
      ...update,
    });
  };

  const onUpdateTrimPiece = (trimPieceIndex, updateObject) => {
    let piecesCopy = [...orderItem[piecesKey]];
    piecesCopy[trimPieceIndex] = {
      ...piecesCopy[trimPieceIndex],
      ...updateObject,
    };

    let update = {};
    update[piecesKey] = piecesCopy;
    onUpdate({
      ...orderItem,
      ...update,
    });
  };

  if (orderItem)
    return (
      <Box>
        <Typography sx={{ flex: 1 }} variant="h6">
          {title}
          {orderItem.totalSellPrice !== undefined &&
          orderItem.totalSellPrice !== null
            ? ` - ${currencyFormatNoDecimals(
                Math.round(Number(orderItem.totalSellPrice ?? 0))
              )}`
            : ""}
        </Typography>

        <Box>
          <Box sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}>
            {trimType === "CopingCapCleat" && (
              <TextField
                sx={{ width: 300 }}
                size="small"
                label="Galvanized Flat Sheet"
                select
                value={orderItem.gauge + orderItem.gaugeUnitOfMeasure}
                onChange={(e) => {
                  let selectedGalvCleatGauge = galvanizedFlatOptions.find(
                    (galvFlat) =>
                      galvFlat.gauge + galvFlat.unitOfMeasure == e.target.value
                  );
                  // GALV FLAT SHEET COST IS NOW STORED IN OVERRIDES (new calcs) instead of ORDER.galvFlatSheetCost (old calcs)
                  let overrides = {
                    ...orderItem.overrides,
                    flat_sheet_cost: selectedGalvCleatGauge.price,
                  };
                  onUpdate({
                    ...orderItem,
                    gauge: selectedGalvCleatGauge.gauge,
                    gaugeUnitOfMeasure: selectedGalvCleatGauge.unitOfMeasure,
                    overrides,
                  });
                }}
              >
                {galvanizedFlatOptions?.map((galvFlat, index) => (
                  <MenuItem
                    key={index}
                    value={galvFlat.gauge + galvFlat.unitOfMeasure}
                  >
                    {galvFlat.gauge} {galvFlat.unitOfMeasure}
                    {isTollForm ? `` : ` - $${galvFlat.price}`}
                  </MenuItem>
                ))}
              </TextField>
            )}

            {trimType === "SplicePlate" ? (
              <AdornedInputDebouncedNoInitialLoad
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Flats Needed"
                value={toTwoDecimals(
                  orderItem.overrides &&
                    orderItem.overrides.flat_sheets_needed !== null &&
                    orderItem.overrides.flat_sheets_needed !== undefined
                    ? orderItem.overrides.flat_sheets_needed
                    : orderItem.variables && orderItem.variables.flats_used
                    ? orderItem.variables.flats_used
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...orderItem.overrides,
                    flat_sheets_needed: e.target.value,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
                isOveridden={
                  orderItem.overrides &&
                  orderItem.overrides.flat_sheets_needed !== null &&
                  orderItem.overrides.flat_sheets_needed !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...orderItem.overrides,
                    flat_sheets_needed: null,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
              />
            ) : (
              <OptimizedFlats
                flatSheetSize={flatSheetSize}
                flatsUsed={orderItem.variables.flats_used ?? 0}
                pieces={orderItem[piecesKey]}
                optimizerData={
                  orderItem.optimizerData
                    ? JSON.parse(orderItem.optimizerData)
                    : null
                }
                onOptimize={(
                  optimizedFlats,
                  totalInchesDrop,
                  optimizerDataUpdate
                ) => {
                  let variables = {
                    ...orderItem.variables,
                    flats_used: optimizedFlats,
                    inches_of_drop: totalInchesDrop,
                  };
                  console.log(optimizerDataUpdate);
                  onUpdate({
                    ...orderItem,
                    variables,
                    optimizerData: JSON.stringify(optimizerDataUpdate),
                  });
                }}
              />
            )}

            {!isTollForm && trimType !== "SplicePlate" && (
              <TextFieldDebouncedNoInitialLoad
                sx={{ width: "100px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                // label="Extra Flats"
                label="FS Adjust"
                value={
                  orderItem.variables && orderItem.variables.extra_flats
                    ? orderItem.variables.extra_flats
                    : 0
                }
                onChange={(e) => {
                  let variables = {
                    ...orderItem.variables,
                    extra_flats: e.target.value,
                  };
                  onUpdate({
                    ...orderItem,
                    variables,
                  });
                }}
              />
            )}

            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                sx={{ width: "100px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Other FS Cost"
                value={toTwoDecimals(
                  orderItem.variables && orderItem.variables.other_fs_cost
                    ? orderItem.variables.other_fs_cost
                    : 0
                )}
                onChange={(e) => {
                  let variables = {
                    ...orderItem.variables,
                    other_fs_cost: e.target.value,
                  };
                  onUpdate({
                    ...orderItem,
                    variables,
                  });
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                sx={{ width: "150px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Material Cost"
                value={toTwoDecimals(
                  orderItem.trimCalculations &&
                    orderItem.trimCalculations.materialCost
                    ? orderItem.trimCalculations.materialCost
                    : 0
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}

            <Box sx={{ width: "150px", marginLeft: "8px" }}>
              <AdornedInputDebouncedNoInitialLoad
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Labor Hrs."
                value={toTwoDecimals(
                  orderItem.overrides &&
                    orderItem.overrides.total_estimated_labor_hours !== null &&
                    orderItem.overrides.total_estimated_labor_hours !==
                      undefined
                    ? orderItem.overrides.total_estimated_labor_hours
                    : orderItem.trimCalculations &&
                      orderItem.trimCalculations.estimatedLaborHours
                    ? orderItem.trimCalculations.estimatedLaborHours
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...orderItem.overrides,
                    total_estimated_labor_hours: e.target.value,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
                isOveridden={
                  orderItem.overrides &&
                  orderItem.overrides.total_estimated_labor_hours !== null &&
                  orderItem.overrides.total_estimated_labor_hours !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...orderItem.overrides,
                    total_estimated_labor_hours: null,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
              />
            </Box>
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                sx={{ width: "150px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Est. Labor Cost"
                value={toTwoDecimals(
                  orderItem.trimCalculations &&
                    orderItem.trimCalculations.estimatedLaborCost
                    ? orderItem.trimCalculations.estimatedLaborCost
                    : 0
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Box>
          <Box
            sx={{ marginTop: "16px", display: "flex", flexDirection: "row" }}
          >
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Material & labor"
                value={toTwoDecimals(
                  orderItem.trimCalculations &&
                    orderItem.trimCalculations.materialAndLabor
                    ? orderItem.trimCalculations.materialAndLabor
                    : 0
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                sx={{ width: "150px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="GP %"
                value={
                  orderItem.variables && orderItem.variables.gross_profit_margin
                    ? toTwoDecimals(
                        orderItem.variables.gross_profit_margin * 100.0
                      )
                    : 0
                }
                onChange={(e) => {
                  let variables = {
                    ...orderItem.variables,
                    gross_profit_margin: Number(e.target.value ?? 0) / 100.0,
                  };
                  onUpdate({
                    ...orderItem,
                    variables,
                  });
                }}
              />
            )}
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                sx={{ width: "150px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="GP $"
                value={toTwoDecimals(
                  orderItem.trimCalculations &&
                    orderItem.trimCalculations.grossProfitDollars
                    ? orderItem.trimCalculations.grossProfitDollars
                    : 0
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}

            <TextFieldDebouncedNoInitialLoad
              sx={{ width: "305px", marginLeft: "8px" }}
              disabled
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Suggested Total Sale Price"
              value={toTwoDecimals(
                orderItem.trimCalculations &&
                  orderItem.trimCalculations.totalSellPrice
                  ? orderItem.trimCalculations.totalSellPrice
                  : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="Start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
            <TextFieldDebouncedNoInitialLoad
              sx={{ width: "305px", marginLeft: "8px" }}
              disabled
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Final Sale Price"
              value={toTwoDecimals(
                orderItem.totalSellPrice ? orderItem.totalSellPrice : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="Start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <Box>
          {orderItem &&
            orderItem[piecesKey] &&
            orderItem[piecesKey].map((piece, index) => {
              return (
                <TrimPiece
                  trimType={trimType}
                  // key={piece.id ?? uuidv4()} // This is causing the refresh. It only happens when the trim piece is unsaved
                  key={piece.id ?? `${piecesKey}-${index}`} // Replace with something consistent
                  piece={piece}
                  onUpdatePiece={(updateObject) => {
                    onUpdateTrimPiece(index, updateObject);
                  }}
                  onRemovePiece={() => {
                    onRemovePiece(index);
                  }}
                />
              );
            })}
        </Box>
        <Box>
          <Button
            onClick={() => {
              if (trimType === "SplicePlate") {
                onAddSplicePlate();
              } else {
                setAddTrimDialogOpen(true);
              }
            }}
          >
            + Add New
          </Button>
          {trimType === "TrimAndFlashing" && (
            <Button
              onClick={() => {
                setOpenMasterCatalog(!openMasterCatalog);
              }}
            >
              + Add From Catalog
            </Button>
          )}
        </Box>
        <AddNewTrimDialog
          trimType={trimType}
          companyId={companyId}
          open={addTrimDialogOpen}
          handleClose={() => {
            setAddTrimDialogOpen(false);
          }}
          handleSubmit={(newTrim) => {
            onAddTrim(newTrim);
          }}
        />
        {trimType === "TrimAndFlashing" && (
          <CompanyTrimCatalogDialog
            companyId={companyId}
            open={openMasterCatalog}
            setOpen={setOpenMasterCatalog}
            // Trim Selected could be a Industry Master Trim or a Saved Trim (default 1 hit and stretchout)
            onItemSelect={(masterTrim) => {
              onAddTrim(masterTrim);
              setOpenMasterCatalog(false);
            }}
          />
        )}
      </Box>
    );
};

export default TrimAndFlashing;
